// @flow
import { buildOptions, makeRequest } from './ServiceHelpers';

const endpointUrl = process.env.REACT_APP_CONTRACT_CONFIG_URL;

export const fetchCurrentConfigV2 = (entityId, entityType) => {
  const options = buildOptions();
  return makeRequest(
    endpointUrl,
    `/api/v2/configuration?entityType=${entityType}&entityId=${entityId}`,
    options,
    'getting user autoapproval configurations'
  );
};

export const updateContractConfigV2 = (entityId, entityType, approvalSettings) => {
  const options = buildOptions({ method: 'PUT', body: JSON.stringify(approvalSettings) });

  return makeRequest(
    endpointUrl,
    `/api/v2/configuration?entityType=${entityType}&entityId=${entityId}`,
    options,
    'updating auto approval'
  );
};
